import { useCallback, useEffect, useRef } from 'react';
import { logger } from '../../utils/logger';

export function useCallCardRingtone(isRinging: boolean) {
  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    const audio = audioRef.current;
    if (isRinging && audio) {
      audio.loop = true;
      audio.play().catch((error) => {
        logger.warn('[CallCard] Could not play ringtone:', error);
      });
    }
    return () => {
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
    };
  }, [isRinging]);

  const stopRingtone = useCallback(() => {
    audioRef.current?.pause();
  }, []);

  return { audioRef, stopRingtone };
}
